import { render, staticRenderFns } from "./productionStageChartWidget.vue?vue&type=template&id=81a08664&"
import script from "./productionStageChartWidget.vue?vue&type=script&lang=js&"
export * from "./productionStageChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports